import React from 'react';
import '../../css/loader.css';

const Loader = () => (
  <div className="loader-wrapper">
    <div className="loader">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
);

export default Loader;